export default () => ({
    siteData: null,
    bookingData: {
        requestedBookings: [],
        deletedBookings: [],
        useDeviatingInvoiceContact: false,
        invoiceRecipient: {
            type: 1,
            overwriteIds: false,
            contactId: null,
            emailId: null,
            salutation: null,
            firstname: null,
            lastname: null,
            address: null,
            email: null
        },
        booker: {
            type: 1,
            overwriteIds: false,
            contactId: null,
            emailId: null,
            mobileId: null,
            phoneId: null,
            salutation: null,
            firstname: null,
            lastname: null,
            phone: null,
            address: null,
            email: null
        },
        bookings: {},
        answers: {},
        payment: {
            paymentType: null,
            bankDetailsId: null,
            iban: null,
            alternativeAccountHolder: null,
        }
    },
    formSelectChoices: null,
    previewMode: false,
    siteIsLoaded: false,
    stepsValidationState: {},
    isAuthenticated: false,
    abilities: [],
    userData: null,
    bookingFinishedSuccessful: false
})
